/**
 * Saves a blob the browser already holds. [AVP-891]
 *
 * The import problem report is fetched with the bearer token and handed here,
 * rather than pointed at with an `<a href>`: the JWT lives in localStorage,
 * not in a cookie, so an anchor navigation reaches the server with no
 * credentials and comes back 401. (`reportDownloadByName` only works that way
 * because AuthorizationFilter has a hard-coded bypass for it, which is not a
 * pattern worth copying.)
 */
export const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // revoked on the next tick: Safari aborts the download if the object URL
  // disappears in the same turn as the click
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const downloadText = (text: string, fileName: string, type = 'text/csv'): void => {
  downloadBlob(new Blob([text], { type: `${type};charset=utf-8;` }), fileName);
};

export default downloadBlob;
